import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chennai',
  templateUrl: './chennai.component.html',
  styleUrls: ['./chennai.component.scss']
})
export class ChennaiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  numb: any=[
    {
      n:'1',
      xy:'43px 0 0 86px'
    },
    {
      n:'2',
      xy:''
    },
    {
      n:'3',
      xy:''
    },
    {
      n:'4',
      xy:''
    },
    {
      n:'5',
      xy:''
    },
    {
      n:'6',
      xy:''
    },
    {
      n:'7',
      xy:''
    },
    {
      n:'8',
      xy:''
    },
    {
      n:'9',
      xy:''
    },
    {
      n:'10',
      xy:''
    },
    {
      n:'11',
      xy:''
    },
    {
      n:'12',
      xy:''
    },
    {
      n:'13',
      xy:''
    },
    {
      n:'14',
      xy:''
    },
    {
      n:'15',
      xy:''
    },
    {
      n:'16',
      xy:''
    },
    {
      n:'17',
      xy:''
    },
    {
      n:'18',
      xy:''
    },
    {
      n:'19',
      xy:''
    },
    {
      n:'20',
      xy:''
    },
    {
      n:'21',
      xy:''
    },
    {
      n:'22',
      xy:''
    },
    {
      n:'23',
      xy:''
    },
    {
      n:'24',
      xy:''
    },
    {
      n:'25',
      xy:''
    },
    {
      n:'26',
      xy:''
    },
    {
      n:'27',
      xy:''
    },
    {
      n:'28',
      xy:''
    },
    {
      n:'29',
      xy:''
    },
    {
      n:'30',
      xy:''
    },
    {
      n:'31',
      xy:''
    },
    {
      n:'32',
      xy:''
    },
    {
      n:'33',
      xy:''
    },
    {
      n:'34',
      xy:''
    },
    {
      n:'35',
      xy:''
    },
    {
      n:'36',
      xy:''
    },
    {
      n:'37',
      xy:''
    },
    {
      n:'38',
      xy:''
    },
    {
      n:'39',
      xy:''
    },
    {
      n:'40',
      xy:''
    },
    {
      n:'41',
      xy:''
    },
    {
      n:'42',
      xy:''
    },
    {
      n:'43',
      xy:''
    },
    {
      n:'44',
      xy:''
    },
    {
      n:'45',
      xy:''
    },
    {
      n:'46',
      xy:''
    },
    {
      n:'47',
      xy:''
    },
    {
      n:'48',
      xy:''
    },
    {
      n:'49',
      xy:''
    },
    {
      n:'50',
      xy:''
    },
    {
      n:'51',
      xy:''
    },
    {
      n:'52',
      xy:''
    },
    {
      n:'53',
      xy:''
    },
    {
      n:'54',
      xy:''
    },
    {
      n:'55',
      xy:''
    },
    {
      n:'56',
      xy:''
    },
    {
      n:'57',
      xy:''
    },
    {
      n:'58',
      xy:''
    },
    {
      n:'59',
      xy:''
    },
    {
      n:'60',
      xy:''
    },
    {
      n:'61',
      xy:''
    },
    {
      n:'62',
      xy:''
    },
    {
      n:'63',
      xy:''
    },
    {
      n:'64',
      xy:''
    },
    {
      n:'65',
      xy:''
    },
    {
      n:'66',
      xy:''
    },
    {
      n:'67',
      xy:''
    },
    {
      n:'68',
      xy:''
    },
    {
      n:'69',
      xy:''
    },
    {
      n:'70',
      xy:''
    },
    {
      n:'71',
      xy:''
    },
    {
      n:'72',
      xy:''
    },
    {
      n:'73',
      xy:''
    },
    {
      n:'74',
      xy:''
    },
    {
      n:'75',
      xy:''
    },
    {
      n:'76',
      xy:''
    },
    {
      n:'77',
      xy:''
    },
    {
      n:'78',
      xy:''
    },
    {
      n:'79',
      xy:''
    },
    {
      n:'80',
      xy:''
    },
    {
      n:'81',
      xy:''
    },
    {
      n:'82',
      xy:''
    },
    {
      n:'83',
      xy:''
    },
    {
      n:'84',
      xy:''
    },
    {
      n:'85',
      xy:''
    },
    {
      n:'86',
      xy:''
    },
    {
      n:'87',
      xy:''
    },
    {
      n:'88',
      xy:''
    },
    {
      n:'89',
      xy:''
    },
    {
      n:'90',
      xy:''
    },
    {
      n:'91',
      xy:''
    },
    {
      n:'92',
      xy:''
    },
    {
      n:'93',
      xy:''
    },
    {
      n:'94',
      xy:''
    },
    {
      n:'95',
      xy:''
    },
    {
      n:'96',
      xy:''
    },
    {
      n:'97',
      xy:''
    },
    {
      n:'98',
      xy:''
    },
    {
      n:'99',
      xy:''
    },
    {
      n:'100',
      xy:''
    },
    {
      n:'101',
      xy:''
    },
    {
      n:'102',
      xy:''
    },
    {
      n:'103',
      xy:''
    },
    {
      n:'104',
      xy:''
    },
    {
      n:'105',
      xy:''
    },
    {
      n:'106',
      xy:''
    },
    {
      n:'107',
      xy:''
    },
    {
      n:'108',
      xy:''
    },
    {
      n:'109',
      xy:''
    },
    {
      n:'110',
      xy:''
    },
    {
      n:'111',
      xy:''
    },
    {
      n:'112',
      xy:''
    },
    {
      n:'113',
      xy:''
    },
    {
      n:'114',
      xy:''
    },
    {
      n:'115',
      xy:''
    },
    {
      n:'116',
      xy:''
    },
    {
      n:'117',
      xy:''
    },
    {
      n:'118',
      xy:''
    },
    {
      n:'119',
      xy:''
    },
    {
      n:'120',
      xy:''
    },
    {
      n:'121',
      xy:''
    },
    {
      n:'122',
      xy:''
    },
    {
      n:'123',
      xy:''
    },
    {
      n:'124',
      xy:''
    },
    {
      n:'125',
      xy:''
    },
    {
      n:'126',
      xy:''
    },
    {
      n:'127',
      xy:''
    },
    {
      n:'128',
      xy:''
    },
    {
      n:'129',
      xy:''
    },
    {
      n:'130',
      xy:''
    }
  ];
}
